import { styled} from 'stitches.config'

export const AllProductsRoot = styled('div', {
    background: '$tertiary-200',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '$2',
    padding: '$5',
    display: 'none',

    '@bp2': { display: 'flex' },
})